import React, { useContext, useMemo } from "react";
import { orderBy } from "lodash";
import PropTypes from "prop-types";

import SearchPageContext from "pages/SearchPageV1/SearchPageV1Context";
import { Section } from "components/core/Page";
import SearchToolbar from "components/organisms/search/SearchToolbar/SearchToolbar";
import FacilityCards from "components/organisms/search/FacilityCards/FacilityCards";
import NoResults from "components/search/SearchResults/NoResults";
import classnames from "classnames";
import "./SearchResults.scss";

const SkeletonFacilityCard = () => (
	<div className="facility-card-skeleton">
		<div className="facility-card-skeleton__media" />
		<div className="facility-card-skeleton__body">
			<div className="facility-card-skeleton__line facility-card-skeleton__line--title" />
			<div className="facility-card-skeleton__line" />
			<div className="facility-card-skeleton__line facility-card-skeleton__line--short" />
		</div>
	</div>
);

const SKELETON_IDS = Array.from({ length: 6 }, (_, i) => `skeleton-${i}`);

const SearchResults = ({
	facilityCards = [],
	selectedFacilityId,
	hoveredFacilityId,
	onFacilityHover,
	subPageType,
}) => {
	const { isFiltering, totalListings } = useContext(SearchPageContext);
	const sortedFacilityCards = useMemo(
		() => orderBy(facilityCards, ["sortId"], ["asc"]),
		[facilityCards]
	);

	const hasResults = typeof totalListings === "number" && totalListings > 0;
	const showNoResults = !isFiltering && !hasResults;

	return (
		<Section className="search-results">
			{hasResults && <SearchToolbar count={totalListings} />}
			{showNoResults && <NoResults />}
			<div
				className={classnames("search-results-items", { isFiltering })}
			>
				{isFiltering &&
					SKELETON_IDS.map((id) => <SkeletonFacilityCard key={id} />)}
				{!isFiltering && hasResults && (
					<FacilityCards
						totalListings={totalListings}
						cards={sortedFacilityCards}
						selectedFacilityId={selectedFacilityId}
						hoveredFacilityId={hoveredFacilityId}
						onFacilityHover={onFacilityHover}
						subPageType={subPageType}
					/>
				)}
			</div>
		</Section>
	);
};

SearchResults.propTypes = {
	facilityCards: PropTypes.arrayOf(PropTypes.object),
	selectedFacilityId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	hoveredFacilityId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	onFacilityHover: PropTypes.func,
	subPageType: PropTypes.string,
};

export default SearchResults;
